import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
//const API_USER = `${API_URL}/events/username`;

class EventService {
  getEvents() {
    return axios.get(API_URL);
  }

  getEventsByUser(username) {
    return axios.get(`${API_URL}/username/${username}`);
  }

  createEvent(event, file) {
    const formData = new FormData();
  
    // Append event as application/json
    const eventBlob = new Blob([JSON.stringify(event)], { type: 'application/json' });
    formData.append('event', eventBlob);
  
    // Append file as multipart/form-data
    if (file) {
      formData.append('file', file);
    }
  
    return axios.post(API_URL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type explicitly
      },
    });
  }

  updateEvent(id, event, file) {
    const formData = new FormData();
  
    // Append event as application/json
    const eventBlob = new Blob([JSON.stringify(event)], { type: 'application/json' });
    formData.append('event', eventBlob);
  
    // Append file as multipart/form-data
    if (file) {
      formData.append('file', file);
    }
  
    return axios.put(`${API_URL}/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type explicitly
      },
    });
  }
  deleteEvent(id) {
    return axios.delete(`${API_URL}/${id}`);
  }
}

export default new EventService();
